import React from 'react';
import { Navigation } from '../../components/Navigation';
import HeroSection from '../../components/HeroSection';
import Footer from '../../components/Footer';
import { TrustSection, LandTypesSection, ProcessSection } from './sections/CoreSections';
import { ListingsSection, AndreasHeinrichsSection, BuyerPathSection, KnowledgeSection, FaqSection, FinalCtaSection } from './sections/TrustSections';
import { ReviewsSection } from './sections/ReviewsSection';
import { SocialSection } from './sections/SocialSection';
import { useHomeSeo } from './useHomeSeo';

export { AndreasHeinrichsSection };

const Home = () => {
  useHomeSeo();
  return (
    <div className="hv-home ak-home min-h-screen bg-[#F8F6F0]" data-testid="homepage">
      <Navigation />
      <main>
        <HeroSection />
        <TrustSection />
        <LandTypesSection />
        <ProcessSection />
        <ListingsSection />
        <AndreasHeinrichsSection />
        <SocialSection />
        <ReviewsSection />
        <BuyerPathSection />
        <KnowledgeSection />
        <FaqSection />
        <FinalCtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
